export const emptyArrowFunction = () => {};

export const cardNumberInitialValue = {
  firstGroup: "",
  secondGroup: "",
  thirdGroup: "",
  fourthGroup: "",
};

export const expirationDateInitialValue = {
  month: "",
  year: "",
};

export const passwordInitialValue = { first: "", second: "" };
